module.exports = __webpack_public_path__ + "img/PD1505108570428014592.4f3612dd.png";